import {useEffect, useState} from "react";
import CardModel from "../../components/CardModel/CardModel";
import "../pagesGlabal.css";
import "../../personaliza-styles.css";
import {servicioObtenerVehiculos} from "../../../../services/configuraHyundai";

const Configura = (props) => {
    const [listaAutos, setListaAutos] = useState([]);
    const [listaSUV, setListaSUV] = useState([]);
    useEffect(() => {
        servicioObtenerVehiculos()
            .then((response) => {
                    var listaAutos = [];
                    var listaSUV = [];
                    var listaVAN = [];
                    response.forEach(
                        (modelo) => {
                            // 1 es AUTO, 2 es SUV, 5 es VAN
                            if (modelo.MOD_TIPO_MODELO === 1 ) {
                                listaAutos.push(modelo);
                            } else if (modelo.MOD_TIPO_MODELO === 2 || modelo.MOD_TIPO_MODELO === null) {
                                listaSUV.push(modelo)
                            } else {
                                listaVAN.push(modelo)
                            }
                        }
                    )
                    setListaAutos(listaAutos);
                    setListaSUV(listaSUV);
                }
            ).catch((err) => {
            console.log(err)
        })
    }, [])

    return (
        <div>
            <section>
                <div className='mt-5 mb-5'>
                    <h2 className="sub-title-home mt-5">
                        AUTOS
                    </h2>
                    <CardModel listaModelos={listaAutos}/>
                    <h2 className="sub-title-home mt-5">
                        SUVs
                    </h2>
                    <CardModel listaModelos={listaSUV}/>
                    <h2 className="sub-title-home mt-5">
                        VAN
                    </h2>
                    <p className="text-center">Próximamente ...</p>
                </div>
            </section>
        </div>
    );
};
export default Configura;